import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { certificatesApi, type UploadCertificatePayload } from './api';

export const certificateKeys = {
  all: ['certificates'] as const,
  byCnpj: (cnpjId: string | null) => ['certificates', 'cnpj', cnpjId] as const,
};

export function useCertificate(cnpjId: string | null) {
  return useQuery({
    queryKey: certificateKeys.byCnpj(cnpjId),
    queryFn: () => certificatesApi.get(cnpjId!),
    enabled: !!cnpjId,
  });
}

export function useCertificateMutations(cnpjId: string | null) {
  const qc = useQueryClient();
  const invalidate = (): void => {
    qc.invalidateQueries({ queryKey: certificateKeys.byCnpj(cnpjId) });
    qc.invalidateQueries({ queryKey: certificateKeys.all });
  };

  const upload = useMutation({
    mutationFn: (payload: UploadCertificatePayload) =>
      certificatesApi.upload(cnpjId!, payload),
    onSuccess: invalidate,
  });

  const remove = useMutation({
    mutationFn: () => certificatesApi.remove(cnpjId!),
    onSuccess: invalidate,
  });

  return { upload, remove };
}
